@if (mask) {
  <span class="custom-mask--autocomplete" [ngClass]="{focused: focus || text.length > 0, 'align-right': alignRight}"
    ><span class="custom-mask--transparent">{{ text }}</span
    ><span class="custom-mask--mask">{{ mask }}</span>
  </span>
}
